import { environment } from './../../environments/environment';
import { Router } from '@angular/router';
import { AuthUser } from './../auth/_models/auth-user';
import { SessionService } from './../auth/_services/session.service';
import { User } from './../auth/_models/user';
import { AngularFirestore } from 'angularfire2/firestore';
import { Injectable } from '@angular/core';
import * as firebase from 'firebase/app';
import { Observable } from 'rxjs/Observable';
import { AngularFireAuth } from 'angularfire2/auth';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { isNullOrUndefined } from 'util';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AuthenticationService {
  public firebaseUser: Observable<firebase.User>;
  // public currentFirebaseUser: any;
  public loggedIn = new BehaviorSubject<boolean>(false);

  constructor(
    private _tostr: ToastrService,
    private _afAuth: AngularFireAuth,
    private _firestore: AngularFirestore,
    private _sessionService: SessionService,
    private _router: Router,
  ) {

    this.firebaseUser = this._afAuth.authState;

    /** Necessário para informar ao sistema se o usuário está logado ou não. */
    this.firebaseUser.subscribe(
      (data) => {
        if (!isNullOrUndefined(data)) {
          // this.loggedIn.next(true);
          this.setFirebaseUser(data);
        } else {
          this.loggedIn.next(false);
        }
      }
    );
  }

  private setFirebaseUser(firebase_user) {

    const that = this;

    let user_data: User;
    let auth_user: AuthUser;

    /** */
    auth_user = new AuthUser({
      uid: firebase_user.uid,
      displayName: firebase_user.displayName,
      email: firebase_user.email,
      refreshToken: firebase_user.refreshToken
    });

    /**
     *
     */
    this._firestore
      .collection<User>('users')
      .ref
      // .where('auth_uuid', '==', auth_user.uid)
      .where('email', '==', auth_user.email)
      .get()
      .then(function (querySnapshot) {
        if (querySnapshot.size === 1) {

          user_data = new User({
            ...{ uuid: querySnapshot.docs[0].id },
            ...querySnapshot.docs[0].data(),
            ...{ auth_user: auth_user }
          });

          that._sessionService.setUser(user_data);
        }
      })
      .catch(function (error) {
        console.log('Error getting user: ', error);
      });

    /** Notifica que o usuário está logado */
    this.loggedIn.next(true);

  }

  login(email: string, password: string) {
    return this._afAuth.auth
      .signInWithEmailAndPassword(email, password)
      .then(data => {
        if (!isNullOrUndefined(data.user) && data.user.emailVerified) {
          this.setFirebaseUser(data.user);
        }
        return data.user;
      })
      .catch(error => {
        this._tostr.error('Login inválido');
        return error;
      });
  }

  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }

  logout() {
    this.loggedIn.next(false);
    this._afAuth.auth.signOut();
  }

  verify() {
    return this._afAuth.authState;
  }

  sendActivationEmail() {
    return this._afAuth.auth.currentUser.sendEmailVerification({
      url: environment.defaultUrl
    });
  }

  restorePassword(email: string) {
    return this._afAuth.auth.sendPasswordResetEmail(email, {
      url: environment.defaultUrl
    });
  }

  redirect() {

    if (this._afAuth.auth.currentUser) {

      this._afAuth.auth.currentUser.getIdTokenResult()
        .then((idTokenResult) => {

          // console.log(JSON.stringify(idTokenResult));

          this._sessionService.setClaims(idTokenResult.claims);

          if (idTokenResult.claims.vet) {
            this._router.navigate(['/pets']);
          } else if (idTokenResult.claims.guardian) {
            this._router.navigate(['/meus-pets']);
          } else if (idTokenResult.claims.admin) {
            this._router.navigate(['/veterinarios']);
          }

        })
        .catch((error) => {
          console.log(error);
        });
    }

  }
}
